import React, { Component } from 'react';
import { ProjectSample, MobileProjectSample } from './projectSample';
import '../style/viewProjects.css';

export class ProjectView extends Component {
	componentWillMount() {
		document.title = this.props.match.params.type.charAt(0).toUpperCase() + this.props.match.params.type.substr(1);
	}

	render() {
		return (
			<div className="projectview">
				{this.props.data.projects
					.filter(
						(proj) =>
							this.props.match.params.type === 'all' ? true : proj.type === this.props.match.params.type
					)
					.sort(
						(a, b) =>
							this.props.match.params.sort === 'alphabetical'
								? String(a['name']).localeCompare(String(b['name']))
								: parseInt(b['date'], 10) - parseInt(a['date'], 10)
					)
					.map((project, idx) => <ProjectSample key={'project' + idx} project={project} />)}
			</div>
		);
	}
}

export class MobileProjectView extends Component {
	componentWillMount() {
		document.title = this.props.match.params.type.charAt(0).toUpperCase() + this.props.match.params.type.substr(1);
	}

	render() {
		return (
			<div className="projectview">
				{this.props.data.projects
					.filter((proj) => proj.type === this.props.match.params.type)
					.sort(
						(a, b) =>
							this.props.match.params.sort === 'alphabetical'
								? String(a['name']).localeCompare(String(b['name']))
								: parseInt(b['date'], 10) - parseInt(a['date'], 10)
					)
					.filter((proj) => proj.type === this.props.match.params.type)
					.map((project, idx) => <MobileProjectSample key={'project' + idx} project={project} />)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/viewProjects.js